var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"titleBar",class:{t_b : _vm.border}},[_c('i',{on:{"click":_vm.back}}),(_vm.title)?[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")]:_c('p',_vm._l((_vm.tabs_arr),function(k,i){return _c('span',{class:{'cur' : _vm.tab_cur == k},on:{"click":function($event){return _vm.tab_event(k)}}},[_vm._v(_vm._s(i))])}),0)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }